import objectUtils from '../utils/object-utils'

export default class ProviderOrder {
  constructor (options = {}) {
    this.model = 'ProviderOrder'

    // RouteLeaf attributes
    this.id = objectUtils.get(options, 'id', null)
    this.order_status = objectUtils.get(options, 'order_status', null)
    this.payment_status = objectUtils.get(options, 'payment_status', null)
    this.expected_delivery_date = objectUtils.get(options, 'expected_delivery_date', null)

    // Third-party attributes
    this.provider_alias = objectUtils.get(options, 'provider_alias', null)
    this.thirdparty_order_id = objectUtils.get(options, 'thirdparty_order_id', null) // used for API requests
    this.thirdparty_account_id = objectUtils.get(options, 'thirdparty_account_id', null)
    this.thirdparty_brand_id = objectUtils.get(options, 'thirdparty_brand_id', null)
    this.thirdparty_order_number = objectUtils.get(options, 'thirdparty_order_number', null)
    this.thirdparty_invoice_id = objectUtils.get(options, 'thirdparty_invoice_id', null)
    this.thirdparty_status = objectUtils.get(options, 'thirdparty_status', null)
    this.vendor_id = objectUtils.get(options, 'vendor_id', null)
    this.shipper_info = objectUtils.get(options, 'shipper_info', null)
    this.receiver_info = objectUtils.get(options, 'receiver_info', null)
    this.vendor_id = objectUtils.get(options, 'vendor_id', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)

    // Associations
    if (options.order_details) this.order_details = options.order_details
  }
}
